const genres = [
  'Action and Adventure',
  'Economy',
  'Classics',
  'Comic Book',
  'Graphic Novel',
  'Detective and Mystery',
  'Fantasy',
  'Historical Fiction',
  'Literary Fiction',
  'Science Fiction',
  'Horror',
  'Romance',
  'Suspense and Thrillers',
];

export default genres;
